import { render, staticRenderFns } from "./ReminderChip.vue?vue&type=template&id=0a1fe3e2"
import script from "./ReminderChip.vue?vue&type=script&lang=js"
export * from "./ReminderChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports